import { CampaignFilterInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React from 'react'
import { t } from '@lingui/macro'
import { filterDescriptionMapper } from '../components/campaign-audience/CampaignFiltersList'

export const HumanReadableFilters: React.FC<{
  filters: CampaignFilterInput[]
}> = ({ filters }) => {
  return (
    <div className="CampaignDetailSubpage__audience-text">
      {filters.map((filter, index) => {
        const FilterHumanized = filterDescriptionMapper[filter.type]

        return (
          <React.Fragment key={index}>
            <FilterHumanized {...filter} />
            {index < filters.length - 1 ? ` ${t`and`} ` : ''}
          </React.Fragment>
        )
      })}
    </div>
  )
}
